import {Component, EventEmitter, Input, Output} from '@angular/core';
import {appointmentAssistanceTypeIcons} from '@shared/constants/appointment.constants';
import {AppConfigService} from '@shared/services/app-config.service';
import {configVariableValues} from '@shared/constants/config-variable-values.constants';

@Component({
  selector: 'si-appo-appointment-highlight',
  templateUrl: './appo-appointment-highlight.component.html',
  styleUrls: ['./appo-appointment-highlight.component.scss']
})
export class AppoAppointmentHighlightComponent {
  @Input() appoId: number;
  @Input() startDate: number;
  @Input() centerName: string;
  @Input() centerAddress: string;
  @Input() centerLatitude: number;
  @Input() centerLongitude: number;
  @Input() professionalName: string;
  @Input() serviceName: string;
  @Input() assistanceTypeCode: string;
  @Input() reasonName: string;
  @Input() collectiveName: string;
  @Input() secondary: boolean;
  @Input() arrivalStartDate: number;
  @Input() arrivalEndDate: number;
  @Input() cardNumberSEOGA: string;
  @Input() actions: string[];
  @Input() forceMobile = false;
  @Output() appoAttendanceConfirmed = new EventEmitter<any>();
  appointmentAssistanceTypeIcons = appointmentAssistanceTypeIcons;
  multipleInsuranceAvailable: boolean;

  constructor(
    private appConfigService: AppConfigService
  ) {
    this.multipleInsuranceAvailable = this.appConfigService.hasConfigurationEnabled(configVariableValues.MULTIPLE_INSURANCE_AVAILABLE);
  }

  onConfirmAttendance(): void {
    this.appoAttendanceConfirmed.emit();
  }
}
